/** The kept-terms list's edits, as pure steps so the tests at the root can run them. */

/** The list with one more word, or null when there is nothing new to add (empty, or already on it, in any case). */
export function addKeepTerm(terms: readonly string[], raw: string): string[] | null {
  const term = raw.trim().replace(/\s+/g, " ").slice(0, 60);
  if (!term) return null;
  if (terms.some((one) => one.toLowerCase() === term.toLowerCase())) return null;
  return [...terms, term];
}

/** The list without a word. */
export function removeKeepTerm(terms: readonly string[], term: string): string[] {
  return terms.filter((one) => one !== term);
}
